export enum A11yComplianceEnum {
	NON_COMPLIANT = 'non-compliant',
	PARTIALLY_COMPLIANT = 'partially-compliant',
	FULLY_COMPLIANT = 'fully-compliant'
}

export const A11Y_COMPLIANCE_ENUM_VALUES = Object.values(A11yComplianceEnum);
